import IDatePickerPayload from '../types/DatePickerPayload';

class Validator {
  public static validate(testName: string, value: any, arg: any = null) {
    const response = { hasError: true, message: '' };

    switch (testName) {
      case 'required':
        if (arg === 'date') {
          response.message = value && Validator.notEmpty(value.inputValue) ? '' : 'This is a required field';
        } else {
          if (typeof value === 'string') {
            value = value.trim();
          }
          response.message = Validator.notEmpty(value) ? '' : 'This is a required field';
        }
        break;
      case 'email':
        response.message = Validator.isEmail(value) || value === '' ? '' : 'Not a valid email';
        break;
      case 'maxLength':
        response.message =
          Validator.maxLength(value, arg) || value === '' ? '' : 'Maximum of ' + arg + ' characters allowed';
        break;
      case 'minLength':
        response.message =
          Validator.minLength(value, arg) || value === '' ? '' : 'Minimum of ' + arg + ' characters required';
        break;
      case 'integer':
        response.message = Validator.isInteger(value) || value === '' ? '' : 'Only numbers are allowed';
        break;
      case 'timeChars':
        response.message = Validator.isTimeChars(value) || value === '' ? '' : 'Only numbers and colon allowed';
        break;
      case 'hoursMinutes':
        response.message = Validator.isHoursMinutesFormat(value) || value === '' ? '' : 'Not a valid time';
        break;
      case 'dateFormat':
        response.message = Validator.matchesDateFormat(value) ? '' : `Invalid date format`;
        break;
      default:
        // eslint-disable-next-line no-console
        console.error(testName + ' is not a valid request for the Validator service');
        return;
    }
    if (response.message === '') {
      response.hasError = false;
    }
    return response;
  }

  // Required
  public static notEmpty(value: any) {
    return value !== undefined && value !== null && value !== '' && !Number.isNaN(value) && value !== false;
  }

  // Email
  public static isEmail(value: string) {
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(String(value).toLowerCase());
  }

  // Maximum character length
  public static maxLength(value: string, num: number) {
    return value.length <= num;
  }

  // Minimum character length
  public static minLength(value: string, num: number) {
    return value.length >= num;
  }

  public static isInteger(value: string) {
    return Number.isInteger(+value) && !value.toString().includes('.');
  }

  public static isTimeChars(value: string) {
    return /^[0-9:]*$/.test(value);
  }

  public static isHoursMinutesFormat(value: string | null, allowMilitary = true) {
    if (value === null) {
      return false;
    } else if (allowMilitary) {
      return /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
    } else {
      return /^([0-9]|1[0-2]):[0-5][0-9]$/.test(value);
    }
  }

  // dateObj?: { value?: Date, inputValue: string }
  public static matchesDateFormat(dateObj: IDatePickerPayload) {
    if (dateObj !== null) {
      // dateObj.value is only not null when the datepicker validates the input value.
      return dateObj.inputValue === '' || dateObj.value !== null;
    } else {
      return true;
    }
  }
}

export default Validator;
